import React, { useContext, useEffect, useState } from "react";
import SpotLight from "./spotLight";
import Featured from "./featured";
import home from "../../assets/icon/home.svg";
import check from "../../assets/icon/check-circle.svg";
import sun from "../../assets/icon/sun.svg";
import settings from "../../assets/icon/settings.svg";
import list from "../../assets/icon/list-for-sale.svg";
import close from "../../assets/icon/close.svg";
import arrow from "../../assets/icon//chevron-down-extra-small.svg";
import { useNavigate } from "react-router-dom";
import Market from "./market";
import Blacklist from "./blacklist";
import SiteSetting from "./siteSetting";
import Whitelist from "./whitelist";
import Dashboard from "./dashboard";
import ArtistApllied from "./artistapplied";
import CollectionApplied from "./collectionApplied";
import { getAdminUser } from "../../firebase/firebase";
import { toast } from "react-toastify";
import { useAccount } from "wagmi";
import { RefreshContext } from "../notificationContext";
import AdminLoader from "../loader/adminLoader";

const Admin = () => {
  const [selectedTab, setSelectedTab] = useState("Dashboard");
  const account = useAccount();
  const { address } = useAccount();
  const [tabMenu, setTabMenu] = useState(true);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const { isAdmin, setIsAdmin } = useContext(RefreshContext);
  const [adminAddress, setAdminAddress] = useState([]);

  // getting admin data from firebase

  useEffect(() => {
    const getAdmin = async () => {
      try {
        const admin = await getAdminUser();
        setAdminAddress(admin);
      } catch (error) {
        console.error("Failed to fetch admin user", error);
        toast.error("Failed to fetch admin data");
      } finally {
        setLoading(false);
      }
    };

    getAdmin();
  }, [getAdminUser]);

  // Check if connected address is admin
  useEffect(() => {
    if (!address) {
      navigate("/");
      toast.error("Sign in to access this page");
      return;
    }

    if (loading) return; // Skip check if loading

    const admins = adminAddress?.address;

    if (admins && account.address) {
      if (!admins.includes(account.address)) {
        toast.error("You are not authorized to access this page");
        setIsAdmin(false);
        navigate("/");
      } else {
        setIsAdmin(true);
      }
    } else {
      toast.error("You are not authorized to access this page");
      setIsAdmin(false);
      navigate("/");
    }
  }, [adminAddress, account.address, address, loading, navigate]);
  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <div>
      {loading ? (
        <AdminLoader />
      ) : (
        <div className="admin-dashbooard d-flex">
          <div className="left-content">
            <div className="admin-nav">
              <h6 className="text-capitalize admin-head v-center">
                admin panel
              </h6>
              <div className="admin-menu-links">
                {/* Desktop aside bar */}
                <ul className=" menu-link for-desktop">
                  {/* Dashboard */}
                  <li
                    className={`h-64 v-center pointer ${
                      selectedTab === "Dashboard" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("Dashboard")}
                  >
                    <label className="text-black no-text-transform v-center    justify-content-between  w-100 ps-3 pointer">
                      <span>
                        <img src={home} alt="profile" className="me-3" />
                        Dashboard
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 hide-on-desktop"
                      />
                    </label>
                    {/* <img src={arrow} alt="arror" className="rotate-90 img-18" /> */}
                  </li>
                  {/* Whitelist */}
                  <li
                    className={`h-64 v-center pointer ${
                      selectedTab === "Whitelist" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("Whitelist")}
                  >
                    <label className="text-black no-text-transform v-center    justify-content-between  w-100 ps-3 pointer">
                      <span>
                        <img src={check} alt="profile" className="me-3" />
                        Whitelist
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 hide-on-desktop"
                      />
                    </label>
                  </li>
                  {/* Spotlight */}
                  <li
                    className={`h-64 v-center pointer ${
                      selectedTab === "Spotlight" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("Spotlight")}
                  >
                    <label className="text-black no-text-transform v-center    justify-content-between  w-100 ps-3 pointer">
                      <span>
                        <img src={sun} alt="profile" className="me-3" />
                        Spotlight
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 hide-on-desktop"
                      />
                    </label>
                  </li>{" "}
                  {/* Featured Art */}
                  <li
                    className={`h-64 v-center pointer ${
                      selectedTab === "Featured" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("Featured")}
                  >
                    <label className="text-black no-text-transform v-center    justify-content-between  w-100 ps-3 pointer">
                      <span>
                        <img src={sun} alt="profile" className="me-3" />
                        Featured Art
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 hide-on-desktop"
                      />
                    </label>
                  </li>{" "}
                  {/* Spotlight */}
                  <li
                    className={`h-64 v-center pointer ${
                      selectedTab === "SiteSetting" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("SiteSetting")}
                  >
                    <label className="text-black no-text-transform v-center    justify-content-between  w-100 ps-3 pointer">
                      <span>
                        <img src={settings} alt="profile" className="me-3" />
                        Site Settings
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 hide-on-desktop"
                      />
                    </label>
                  </li>
                  {/* Marketing & Promotions */}
                  <li
                    className={`h-64 v-center pointer ${
                      selectedTab === "Marketing" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("Marketing")}
                  >
                    <label className="text-black no-text-transform v-center    justify-content-between  w-100 ps-3 pointer">
                      <span>
                        <img src={list} alt="profile" className="me-3" />
                        Marketing
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 hide-on-desktop"
                      />
                    </label>
                  </li>
                  {/* Blacklist*/}
                  <li
                    className={`h-64 v-center pointer ${
                      selectedTab === "Blacklist" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("Blacklist")}
                  >
                    <label className="text-black no-text-transform v-center justify-content-between  w-100   ps-3 pointer">
                      <span>
                        <img src={close} alt="profile" className="me-3" />
                        Blacklist
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 hide-on-desktop"
                      />
                    </label>
                  </li>
                  {/* Artist Apllied*/}
                  <li
                    className={`h-64 v-center pointer d-none ${
                      selectedTab === "ArtistApllied" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("ArtistApllied")}
                  >
                    <label className="text-black no-text-transform v-center justify-content-between  w-100   ps-3 pointer">
                      <span>
                        <img src={check} alt="profile" className="me-3" />
                        Artist Applied
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 hide-on-desktop"
                      />
                    </label>
                  </li>
                  {/* collection Applied */}
                  <li
                    className={`h-64 v-center pointer d-none ${
                      selectedTab === "collectionApplied" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("collectionApplied")}
                  >
                    <label className="text-black no-text-transform v-center justify-content-between  w-100   ps-3 pointer">
                      <span>
                        <img src={check} alt="profile" className="me-3" />
                        Collection Applied
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 hide-on-desktop"
                      />
                    </label>
                  </li>
                </ul>

                {/* mobile */}
                <ul className=" menu-link flex-column for-mobile">
                  {/* Dashboard */}
                  <li
                    className="h-64 v-center pointer "
                    onClick={() => navigate("/admin-dashboard")}
                  >
                    <label className="text-black no-text-transform v-center    justify-content-between  w-100 ps-3 pointer">
                      <span>
                        <img src={home} alt="profile" className="me-3" />
                        Dashboard
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 "
                      />
                    </label>
                  </li>
                  {/* Whitelist */}
                  <li
                    className="h-64 v-center pointer "
                    onClick={() => navigate("/whitelist")}
                  >
                    <label className="text-black no-text-transform v-center    justify-content-between  w-100 ps-3 pointer">
                      <span>
                        <img src={check} alt="profile" className="me-3" />
                        Whitelist
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 "
                      />
                    </label>
                  </li>
                  {/* Spotlight */}
                  <li
                    className="h-64 v-center pointer "
                    onClick={() => navigate("/admin-spotlight")}
                  >
                    <label className="text-black no-text-transform v-center    justify-content-between  w-100 ps-3 pointer">
                      <span>
                        <img src={sun} alt="profile" className="me-3" />
                        Spotlight
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 "
                      />
                    </label>
                  </li>
                  {/* Featured Art */}
                  <li
                    className="h-64 v-center pointer "
                    onClick={() => navigate("/featured-art")}
                  >
                    <label className="text-black no-text-transform v-center    justify-content-between  w-100 ps-3 pointer">
                      <span>
                        <img src={sun} alt="profile" className="me-3" />
                        Featured Art
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 "
                      />
                    </label>
                  </li>

                  {/* site-settings */}
                  <li
                    className="h-64 v-center pointer "
                    onClick={() => navigate("/site-settings")}
                  >
                    <label className="text-black no-text-transform v-center    justify-content-between  w-100 ps-3 pointer">
                      <span>
                        <img src={settings} alt="profile" className="me-3" />
                        Site Setting
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 "
                      />
                    </label>
                  </li>
                  {/* Marketing & Promotions */}
                  <li
                    className="h-64 v-center pointer "
                    onClick={() => navigate("/marketing-promotions")}
                  >
                    <label className="text-black no-text-transform v-center    justify-content-between  w-100 ps-3 pointer">
                      <span>
                        <img src={list} alt="profile" className="me-3" />
                        Marketing
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 "
                      />
                    </label>
                  </li>
                  {/* Blacklist*/}
                  <li
                    className="h-64 v-center pointer "
                    onClick={() => navigate("/black-list")}
                  >
                    <label className="text-black no-text-transform v-center justify-content-between  w-100   ps-3 pointer">
                      <span>
                        <img src={close} alt="profile" className="me-3" />
                        Blacklist
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 "
                      />
                    </label>
                  </li>
                  {/* Artist Apllied*/}
                  {/* <li
                    className="h-64 v-center pointer "
                    onClick={() => navigate("/artist-applied")}
                  >
                    <label className="text-black no-text-transform v-center justify-content-between  w-100   ps-3 pointer">
                      <span>
                        <img src={check} alt="profile" className="me-3" />
                        Artist Applied
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 "
                      />
                    </label>
                  </li> */}
                  {/* collection Applied*/}
                  <li
                    className="h-64 v-center pointer d-none"
                    onClick={() => navigate("/collection-applied")}
                  >
                    <label className="text-black no-text-transform v-center justify-content-between  w-100   ps-3 pointer">
                      <span>
                        <img src={check} alt="profile" className="me-3" />
                        Collection Applied
                      </span>
                      <img
                        src={arrow}
                        alt="profile"
                        className="me-3 rotate-270 "
                      />
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="right-content w-100 hide-on-mobile">
            {selectedTab === "Dashboard" ? <Dashboard /> : <></>}
            {selectedTab === "Whitelist" ? <Whitelist /> : <></>}
            {selectedTab === "Spotlight" ? <SpotLight /> : <></>}
            {selectedTab === "Featured" ? <Featured /> : <></>}
            {selectedTab === "SiteSetting" ? <SiteSetting /> : <></>}
            {selectedTab === "Marketing" ? <Market /> : <></>}
            {selectedTab === "Blacklist" ? <Blacklist /> : <></>}
            {selectedTab === "ArtistApllied" ? <ArtistApllied /> : <></>}
            {selectedTab === "collectionApplied" ? (
              <CollectionApplied />
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Admin;
